import { render, staticRenderFns } from "./points-mall.vue?vue&type=template&id=4f138382&scoped=true"
import script from "./points-mall.vue?vue&type=script&lang=js"
export * from "./points-mall.vue?vue&type=script&lang=js"
import style0 from "./points-mall.vue?vue&type=style&index=0&id=4f138382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f138382",
  null
  
)

export default component.exports